import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"
// import NumberFormat from "react-number-format"
// import moment from "moment/moment";

import { Tooltip } from "@mui/material";
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import './tablePresupuesto.css'

//-IMAGES
import agregarCategoria from '../../img/tabla/agregarCategoria.svg'
// import iconCandado from '../../img/tabla/iconCandado.svg'

// import { ItemsActions } from "../ItemsActions"
import abiertoTitulo from '../../img/tabla/abiertoTitulo.svg'
import cerradoTitulo from '../../img/tabla/cerradoTitulo.svg'

import { ItemsActionsMenu } from "./ItemsActionsMenu"

// import { AutocompleteServicios } from "../AutocompleteServicios";
// import { AutocompleteCategorias } from "../AutocompleteCategorias";

// import { DialogDetailItems } from '../DialogDetailItems'

import { budgetsUpdateColumnName } from "../../../../redux/actions/pptos"
import { TablaPptosTitle } from "./TablaPptosTitle";

// const reorder = (list, startIndex, endIndex) => {
//     const result = [...list];
//     const [removed] = result.splice(startIndex, 1);
//     result.splice(endIndex, 0, removed);

//     return result;
// };

const nameColumns = ['Días', 'Meses']

const TablaPptos = ({ addTitle, handleOpenListCompras }) => {
    const dispatch = useDispatch()

    const { categories, services, unidadMedida } = useSelector(state => state.general)
    const { ppto_items_mostrar_fechas, ppto_items_ocultar_dscto, ppto_items_ocultar_dias } = useSelector(state => state.general.detail)

    const { detail } = useSelector(state => state.ppto)
    const { items: detailPttos, separacion_miles, separacion_decimales, simbolo, cant_items, reading_mode, estado_negocio, nombre_columna_dias: currentColumnName, total_utilidad_r } = useSelector(state => state.ppto.detail)

    const [openAllSubTitles, setOpenAllSubTitles] = useState(true)
    const [cantOpenSubtitles, setCantOpenSubtitles] = useState(detailPttos.length)
    const [cantClosedSubtitles, setCantClosedSubtitles] = useState(0)

    const openOrClosedAllSubtitles = useCallback((type) => {
        if (type) {
            setOpenAllSubTitles(true)
            setCantOpenSubtitles(detailPttos.length)
            setCantClosedSubtitles(0)
        } else {
            setOpenAllSubTitles(false)
            setCantOpenSubtitles(0)
            setCantClosedSubtitles(detailPttos.length)
        }
    }, [detailPttos])

    const openOrClosedSubtitleIsAll = (type) => {
        if (type) {
            setCantOpenSubtitles((cantOpenSubtitles + 1))
            if (cantClosedSubtitles > 0) setCantClosedSubtitles((cantClosedSubtitles - 1))
            if ((cantOpenSubtitles + 1) === detailPttos.length) setOpenAllSubTitles(true) //Todos los subtitlos estan abiertos
        } else {
            setCantClosedSubtitles((cantClosedSubtitles + 1))
            if (cantOpenSubtitles > 0) setCantOpenSubtitles((cantOpenSubtitles - 1))
            if ((cantClosedSubtitles + 1) === detailPttos.length) setOpenAllSubTitles(false)//Todos los subtitlos estan cerrados
        }
    }

    // const onDragEndInit = (result) => {
    //     const { source, destination } = result
    //     if (!destination) return false
    //     if (source.index === destination.index) return false
    //     const newOrder1 = reorder(detailPttos, source.index, destination.index)
    //     const newOrder = newOrder1.map((title_, i) => {
    //         title_.sorting = i
    //         return title_
    //     })
    //     const detailPttoOrder = {
    //         ...detail,
    //         items: newOrder
    //     }

    //     dispatch(budgetsLoadDetail(detailPttoOrder))
    // }

    const handleChangeColumnName = (e) => {
        const valueColumnName = e.target.value

        const newDetail = {
            ...detail,
            'nombre_columna_dias': valueColumnName
        }

        dispatch(budgetsUpdateColumnName(newDetail))
    }

    useEffect(() => {
        if (cant_items > 20) {
            openOrClosedAllSubtitles(false)
        }
    }, [cant_items, openOrClosedAllSubtitles])

    return (
        <table className="table table-sm p-table-ppto min-w-ful">
            <thead>
                <HeaderOne
                    cant_items={cant_items}
                    ppto_items_ocultar_dscto={ppto_items_ocultar_dscto}
                    estado_negocio={estado_negocio}
                    ppto_items_mostrar_fechas={ppto_items_mostrar_fechas}
                    ppto_items_ocultar_dias={ppto_items_ocultar_dias}
                    reading_mode={reading_mode}
                    total_utilidad_r={total_utilidad_r}
                />
                <HeaderTwo
                    reading_mode={reading_mode}
                    agregarCategoria={agregarCategoria}
                    addTitle={addTitle}
                    detailPttos={detailPttos}
                    openAllSubTitles={openAllSubTitles}
                    openOrClosedAllSubtitles={openOrClosedAllSubtitles}
                    handleChangeColumnName={handleChangeColumnName}
                    currentColumnName={currentColumnName}
                    ppto_items_ocultar_dscto={ppto_items_ocultar_dscto}
                    simbolo={simbolo}
                    estado_negocio={estado_negocio}
                    ppto_items_mostrar_fechas={ppto_items_mostrar_fechas}
                    ppto_items_ocultar_dias={ppto_items_ocultar_dias}
                />
            </thead>
            <tbody>
                {detailPttos?.map((item, i) => (
                    <TablaPptosTitle
                        key={item.id}
                        detailPtto={item}
                        categories={categories}
                        separacion_miles={separacion_miles}
                        separacion_decimales={separacion_decimales}
                        simbolo={simbolo}
                        services={services}
                        detailPttos_={detailPttos}
                        openAllSubTitles={openAllSubTitles}
                        openOrClosedSubtitleIsAll={openOrClosedSubtitleIsAll}
                        index={i}
                        // placeholder={droppableProvided.placeholder}
                        reading_mode={reading_mode}
                        estado_negocio={estado_negocio}
                        unidadMedida={unidadMedida}
                        handleOpenListCompras={handleOpenListCompras}
                    />
                ))}
            </tbody>
        </table>
    )
}

export default TablaPptos


const HeaderOne = ({ cant_items, ppto_items_ocultar_dscto, estado_negocio, ppto_items_mostrar_fechas, ppto_items_ocultar_dias, reading_mode, total_utilidad_r }) => {

    const { access } = useSelector(state => state.auth)

    return (
        <tr className="p-header-one">

            {!reading_mode &&
                <th className="p-counter-items border-right-separate" id="page-inicio-avance">
                    {/* {cant_items || 0} ítems */}
                </th>
            }

            {ppto_items_ocultar_dscto ?
                <th colSpan={ppto_items_ocultar_dias ? 5 : 6} className="border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                    <div className="d-flex justify-content-between align-items-center" id="page-inicio-avance">
                        <div className="p-counter-items ms-2">{cant_items || 0} ítems</div>
                        <div className="box-labels">
                            <div className='punto-cliente'></div>
                            <span>Cliente / Venta</span>
                        </div>
                        <div></div>
                    </div>
                </th>
                :
                <th colSpan={ppto_items_ocultar_dias ? 7 : 8} className="border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                    <div className="d-flex justify-content-between align-items-center" id="page-inicio-avance">
                        <div className="p-counter-items ms-2">{cant_items || 0} ítems</div>
                        <div className="box-labels">
                            <div className='punto-cliente'></div>
                            <span>Cliente / Venta</span>
                        </div>
                        <div></div>
                    </div>
                </th>
            }

            {access.a20 &&
                <th colSpan={2} className="border-left-separate border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                    <div className="box-labels">
                        <div className='punto-costo'></div>
                        <span>Costos Directos / Estimados</span>
                    </div>
                </th>
            }

            {access.a21 &&
                <th colSpan={2} className="border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                    <div className="box-labels">
                        <div className='punto-rentabilidad'></div>
                        <span className='ms-2 d-flex align-items-center'>
                            <span>Rentabilidad Estimada</span>
                        </span>
                    </div>
                </th>
            }

            {/* modo negocio - actual */}
            {estado_negocio === 'aprobado' &&
                <>
                    {access.a22 &&
                        <th colSpan={3} className="border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className='tabla-punto-ppto'></div>
                                <span className='ms-2 d-flex align-items-center'>
                                    <span>Gasto real</span>
                                </span>
                            </div>
                        </th>
                    }

                    {access.a23 &&
                        <th colSpan={2} className="border-right-separate sticky top-0 bg-white z-20 px-4 py-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className='tabla-punto-rentabilidad'></div>
                                <span className='ms-2 d-flex align-items-center'>
                                    <span>Rentabilidad real</span>
                                </span>
                            </div>
                        </th>
                    }

                </>
            }

            {ppto_items_mostrar_fechas && <th colSpan={2} className="text-center border-right-separate sticky top-0 bg-white z-20 px-4 py-2">Fechas</th>}

            <th className="sticky top-0 bg-white z-20 ">
                <div className="d-flex align-items-center justify-content-center">
                    <ItemsActionsMenu />
                </div>
            </th>

        </tr>
    )
}

const HeaderTwo = ({ reading_mode, agregarCategoria, addTitle, detailPttos, openAllSubTitles, openOrClosedAllSubtitles, handleChangeColumnName, currentColumnName, ppto_items_ocultar_dscto, simbolo, estado_negocio, ppto_items_mostrar_fechas, ppto_items_ocultar_dias }) => {

    const { access } = useSelector(state => state.auth)

    return (
        <tr className="p-header-two">

            {!reading_mode &&
                <th className="border-right-separate">
                    <div>
                        <Tooltip title="Agregar servicios">
                            <img
                                className='tabla-icons-actions'
                                src={agregarCategoria}
                                alt='agregar servicios'
                                onClick={addTitle}
                            />
                        </Tooltip>
                    </div>
                </th>
            }

            <th className="sticky left-0 bg-white z-20 px-4 py-2 border top-[30px]">
                <div className="d-flex justify-content-center align-items-center">
                    {(detailPttos.length > 1) && (
                        openAllSubTitles ?
                            <img
                                onClick={() => openOrClosedAllSubtitles(!openAllSubTitles)}
                                role='button'
                                className='icon-abrir p-1'
                                src={abiertoTitulo}
                                alt='abierto'
                                title='Cerrar sub items'
                                id="contraer-items"
                            />
                            :
                            <img
                                onClick={() => openOrClosedAllSubtitles(!openAllSubTitles)}
                                role='button'
                                className='icon-cerrar p-1'
                                src={cerradoTitulo}
                                alt='cerrado'
                                title='Abrir sub items'
                            />
                    )}
                    <div style={{ width: '100%' }}>Servicios</div>
                </div>
            </th>
            <th className="sticky top-[30px] bg-white z-10">
                <div className="justify-content-end">
                    Cant.
                </div>
            </th>

            {!ppto_items_ocultar_dias &&
                <th className="text-center sticky top-[30px] bg-white z-10">
                    <select
                        style={{ border: 'none', fontSize: '14px', color: 'var(--primary-color-title-table)' }}
                        onChange={handleChangeColumnName}
                    >
                        {nameColumns?.map(columName => {
                            if (columName === currentColumnName) {
                                return <option value={columName} selected>{columName}</option>
                            } else {
                                return <option value={columName}>{columName}</option>
                            }
                        })}
                    </select>
                </th>
            }

            <th class="sticky top-[30px] bg-white z-10">
                <div>
                    Unid.
                </div>
            </th>
            <th scope="col" className="Col-112 sticky top-[30px] bg-white z-10">
                <div className="justify-content-end">
                    Precio unitario
                </div>
            </th>
            <th scope="col" className={`Col-112 bg-col-subtotal ${ppto_items_ocultar_dscto ? 'border-right-separate' : ''} sticky top-[30px] bg-white z-10`}>
                <div className="justify-content-end">
                    <span className='ms-1'>Total</span>
                </div>
            </th>

            {!ppto_items_ocultar_dscto &&
                <>
                    < th scope="col" className="Col-112 sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            Dscto.
                        </div>
                    </th>
                    <th scope="col" className="Col-112 bg-col-subtotal SeparadorCatg sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            <span className='ms-1'>Total</span>
                        </div>
                    </th>
                </>
            }

            {access.a20 &&
                <>
                    <th scope="col" className="Col-112 sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            Costo unitario
                        </div>
                    </th>
                    <th scope="col" className="Col-112 SeparadorCatg sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            <span className='ms-1'>Total</span>
                        </div>
                    </th>
                </>
            }

            {access.a21 &&
                <>
                    <th scope="col" className="Col-112 sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            <span className='ms-1'>Total</span>
                        </div>
                    </th>
                    <th scope="col" className="Col-80 SeparadorCatg sticky top-[30px] bg-white z-10">
                        <div className="justify-content-end">
                            <span className='ms-1'>% Margen</span>
                        </div>
                    </th>
                </>
            }

            {/* modo negocio */}
            {estado_negocio === 'aprobado' &&
                <>

                    {access.a22 &&
                        <>
                            <th scope="col" className="SeparadorCatg sticky top-[30px] bg-white z-10">
                                <div className="justify-content-center">
                                    <span className='ms-1'>Gasto real</span>
                                </div>
                            </th>
                            <th scope="col" className="SeparadorCatg sticky top-[30px] bg-white z-10" colSpan={2}>
                                <div className="justify-content-center">
                                    <span className='ms-1'>Por gastar</span>
                                </div>
                            </th>
                        </>
                    }

                    {access.a23 &&
                        <>
                            <th scope="col" className="sticky top-[30px] bg-white z-10">
                                <div className="justify-content-center">
                                    <span className='ms-1'>Total</span>
                                </div>
                            </th>
                            <th scope="col" className="SeparadorCatg sticky top-[30px] bg-white z-10">
                                <div className="justify-content-center">
                                    <span className='ms-1'>% Margen</span>
                                </div>
                            </th>
                        </>
                    }
                </>
            }

            {ppto_items_mostrar_fechas &&
                <>
                    <th scope="col" className="SeparadorCatg">
                        Inicio
                    </th>

                    <th scope="col" className="SeparadorCatg">
                        Término
                    </th>
                </>
            }

            <th scope="col" className="SeparadorCatg">
                <div className="justify-content-center" id="page-final-avance">
                    <span className='ms-1'>Seleccionar</span>
                </div>
            </th>

        </tr>
    )
}